const PNG_1X1_BASE64 =
  'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

/**
 * PNG de 1x1 como File. Sirve de firma y de foto: los endpoints de entrega y de
 * no entrega validan que el archivo llegue y se guarde en storage, no su
 * contenido.
 */
export const pngPlaceholder = (name: string): File => {
  const binary = atob(PNG_1X1_BASE64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new File([bytes], `${name}.png`, { type: 'image/png' });
};
